import { useMemo } from "react";
import { useLocation } from "react-router";

export function useQuery() {
    const search = useLocation().search;
    return useMemo(() => new URLSearchParams(search), [search]);
}
